<template>
  <main class="page">
    <HeroBanner />
    <HomeStats />

    <!-- 四大品类 -->
    <section class="block block-feature">
      <div class="container">
        <div class="block-head">
          <div class="block-label">CORE BUSINESS</div>
          <h2 class="block-title">四大核心品类 · 一站式制造加工</h2>
          <p class="block-sub">以家用电器、照明灯具、塑料制品、五金件为核心，满足多元化制造与定制需求</p>
        </div>
        <FeatureCards />
      </div>
    </section>

    <AboutPreview />

    <!-- 产品系列 -->
    <section class="block block-product" id="product">
      <div class="container">
        <div class="block-head">
          <div class="block-label">PRODUCT SERIES</div>
          <h2 class="block-title">自主产品系列</h2>
          <p class="block-sub">专注工业定位灯等自研产品的设计、制造与配套服务</p>
        </div>
        <SolutionSection />
      </div>
    </section>

    <SolutionIndustrySection />

    <NewsTabsSection />

    <CtaBanner />

    <SideFloatBar />
  </main>
</template>

<script setup>
import HeroBanner from "@/components/HeroBanner.vue";
import HomeStats from "@/components/HomeStats.vue";
import FeatureCards from "@/components/FeatureCards.vue";
import AboutPreview from "@/components/AboutPreview.vue";
import SolutionSection from "@/components/SolutionSection.vue";
import SolutionIndustrySection from "@/components/SolutionIndustrySection.vue";
import NewsTabsSection from "@/components/NewsTabsSection.vue";
import CtaBanner from "@/components/CtaBanner.vue";
import SideFloatBar from "@/components/SideFloatBar.vue";
</script>

<style scoped>
.page {
  min-height: 100vh;
  background: #fff;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}

.block {
  padding: 92px 0;
}

.block-feature {
  background: #f6f9fd;
}

.block-product {
  background: #fff;
}

.block-head {
  text-align: center;
  margin-bottom: 52px;
}

.block-label {
  display: inline-block;
  padding: 5px 16px;
  border-radius: 999px;
  background: #e8f1fc;
  color: #0a4f97;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 3px;
  margin-bottom: 16px;
}

.block-title {
  font-size: 34px;
  font-weight: 800;
  color: #102a43;
  margin: 0 0 14px;
  line-height: 1.3;
}

.block-sub {
  font-size: 15px;
  color: #7b8a9c;
  margin: 0;
}

@media (max-width: 760px) {
  .block {
    padding: 60px 0;
  }

  .block-title {
    font-size: 26px;
  }
}
</style>
